import { ChangeEvent, FC } from 'react';

import { Grid } from '@mui/material';
import { AddPartnerApplication, CommissionFrequency } from '@prisma/client';
import { UKBankDetails } from 'types/graphql';

import { CustomInput } from 'src/components/CustomInput';
import SortCodeAccountInput from 'src/components/SortCodeAccountInput/SortCodeAccountInput';

export type GBBankDetailsValues = {
    sortCode: string;
    accountNumber: string;
    ibanNumber: string;
    commissionFrequency: CommissionFrequency;
};

type GBBankDetailsProps = {
    values: GBBankDetailsValues;
    setFieldValue: (field: string, value: string) => void;
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
    application: AddPartnerApplication;
    setBankValidationResult: (result: UKBankDetails) => void;
    setValidatingBankDetails: (validating: boolean) => void;
    setLastSortCodeValue: (value: string) => void;
    bankValidationResult?: UKBankDetails;
};

const GBBankDetails: FC<GBBankDetailsProps> = ({
    values,
    setFieldValue,
    handleChange,
    application,
    setBankValidationResult,
    setValidatingBankDetails,
    setLastSortCodeValue,
    bankValidationResult,
}) => {
    const isSuccessfulValidation =
        bankValidationResult?.StatusInformation === 'OK' ||
        bankValidationResult?.StatusInformation === 'CautiousOK';
    const hasEmptyIban = !bankValidationResult?.IBAN;
    const shouldEnableIban = isSuccessfulValidation && hasEmptyIban;

    return (
        <>
            <SortCodeAccountInput
                values={values}
                setFieldValue={setFieldValue}
                handleChange={handleChange}
                setBankValidationResult={(res) => {
                    setBankValidationResult(res);
                }}
                setValidatingBankDetails={setValidatingBankDetails}
                setLastSortCodeValue={setLastSortCodeValue}
            />
            <Grid item xs={12} spacing={2} container>
                <Grid item xs={12} lg={6}>
                    <CustomInput
                        name="accountName"
                        label="Account Name"
                        placeholder="Account Name"
                        value={application?.pi_legalCompanyName || ''}
                        onChange={() => {}}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <CustomInput
                        name="ibanNumber"
                        label="IBAN"
                        placeholder="IBAN"
                        value={values.ibanNumber || ''}
                        onChange={handleChange}
                        disabled={!shouldEnableIban}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default GBBankDetails;
